import { render, staticRenderFns } from "./OtherCategoryCard.vue?vue&type=template&id=00eaa125&scoped=true&"
import script from "./OtherCategoryCard.vue?vue&type=script&lang=js&"
export * from "./OtherCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./OtherCategoryCard.vue?vue&type=style&index=0&id=00eaa125&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eaa125",
  null
  
)

export default component.exports